import { render, staticRenderFns } from "./about03.vue?vue&type=template&id=3cd86324&scoped=true"
import script from "./about03.vue?vue&type=script&lang=js"
export * from "./about03.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd86324",
  null
  
)

export default component.exports